import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=07b7640c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=07b7640c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7640c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b7640c')) {
      api.createRecord('07b7640c', component.options)
    } else {
      api.reload('07b7640c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=07b7640c&scoped=true&", function () {
      api.rerender('07b7640c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKdNSyPAhn4t/JS/comp/PopupDialog.vue"
export default component.exports